module.exports = __webpack_public_path__ + "img/group3.370d17f7.png";